export default {
  namespaced: true,
  state: {
    message: null,
  },
  getters: {
    getMessage(state) {
      return state.message
    },
  },
  mutations: {
    setMessage(state, message) {
      state.message = message
    },
    resetMessage(state) {
      state.message = null
    },
  },
  actions: {
    async setMessage({ commit }, message) {
      commit('setMessage', message)
    },
    async resetMessage({ commit }) {
      commit('resetMessage')
    },
  },
}
